export enum ProductionRequestStatus {
	Pending = 0,
	Declined = 10,
	Approved = 20
}